module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mceltis10-cfea1b6f43b8a8fedca7844c3bc509d0.jpg";